import { GET_AVAILABLE_MILESTONE_TYPES } from '@bechtel/client-gql';

export const MilestoneTypeListRequest = {
  query: GET_AVAILABLE_MILESTONE_TYPES,
};
export const availableMilestoneTypes = [
  {
    id: '1',
    name: 'Staged',
  },
  {
    id: '2',
    name: 'ELT',
  },
  {
    id: '3',
    name: 'Weldout',
  },
  {
    id: '4',
    name: 'Supports',
  },
  {
    id: '5',
    name: 'Punch List',
  },
];

export const MilestoneListData = {
  request: MilestoneTypeListRequest,
  result: {
    data: {
      projectConfigById: {
        id: '1',
        availableMilestoneTypes: availableMilestoneTypes,
      },
    },
  },
};
